import {
  BOTTOM_SIDEBAR_HEIGHT,
  CANVAS_RULER_AREA_WIDTH,
  DISCLAIMER_HEIGHT,
  DISCLAIMER_HEIGHT_SMALL_MODE,
  NEXTGEN_CANVAS_HORIZEN_MARGIN,
  NEXTGEN_CANVAS_MARGIN_INSIDE,
  NEXTGEN_CANVAS_MARGIN_OUTSIDE,
  NEXTGEN_CANVAS_MIN_HEIGHT,
  NEXTGEN_CANVAS_MIN_WIDTH,
  NEXTGEN_HEADER_TOPBAR_HEIGHT,
  NEXTGEN_HEADER_TOPBAR_HEIGHT_SMALL,
  NEXTGEN_RIGHTBAR_HEIGHT,
  NEXTGEN_RIGHTBAR_WIDTH,
  canvasContextMenuEnum,
  nextgenNodeId,
  nextgenScreenMode,
} from '../constants';
import {
  MAX_CANVAS_SCALE,
  MAX_CLOUD_IMAGE_SIZE,
  MAX_UPLOAD_LOGO_SIZE,
  domNodeId,
  elementStatus,
  elementType,
  logoEditingStatusEnum,
  stepStatus,
  userImageType,
} from '../../utils/constants';
import {
  adjustImageSizeToFitContainer,
  getOutlineCenter,
  getRectPoints,
  getRotateResult,
  getVignetteCanvasInfo,
  rotateText,
} from '../../canvas/logics';
import {
  changeCanvasResizeParameters,
  changeImagePosition,
  changeTextPosition,
  resizeElement,
  selectImage,
  selectText,
  unSelectAllImage,
  unSelectAllText,
} from '../../canvas/actions';
import { changePanelForSingleSelect, getScreenMode } from '../logics';
import { checkPointInRect, checkRectOutsideRect } from '../../tools/logics';
import { getRealPosToKeepElementInside, keepTextElementInCanvas } from '../../elements/components/BaseElement/logics';

import { changeNextgenUiStatus } from '../actions';
import { getDeviceViewPort } from '../../utils/device';
import { getRectCenter } from '../elements/BaseElement/logics';
import { isMobileOnly } from 'react-device-detect';
import { isOnFoldLine } from '../../elements/utils';
import { studioItemType as studioItemTypeEnum } from '../../main/constants';

export const getResizeWindowInfo2 = (canvasData) => {
  const originCanvasWidth = canvasData.fullWidth;
  const viewPort = getDeviceViewPort();

  let canvasScale = 1;
  let sideBarWidth;
  let canvasAreaWidth;

  const leftSideBar = document.getElementById(nextgenNodeId.leftSideBar);
  let leftSideBarWidth = 0;
  let leftFlyoutWidth = 0;
  if (leftSideBar) {
    leftSideBarWidth = leftSideBar === null ? 0 : leftSideBar.getBoundingClientRect().width;
    const leftFlyout = document.getElementById(nextgenNodeId.leftFlyoutContent);
    leftFlyoutWidth = leftFlyout === null ? 0 : leftFlyout.getBoundingClientRect().width;
  }

  const screenMode = getScreenMode();
  const fixedWidth =
    screenMode === nextgenScreenMode.small
      ? 0
      : screenMode === nextgenScreenMode.middle
      ? leftSideBarWidth + NEXTGEN_CANVAS_HORIZEN_MARGIN
      : leftSideBarWidth + leftFlyoutWidth + NEXTGEN_CANVAS_HORIZEN_MARGIN;

  sideBarWidth = leftFlyoutWidth;
  const rightBarWidth = screenMode === nextgenScreenMode.small ? 0 : NEXTGEN_RIGHTBAR_WIDTH;
  canvasAreaWidth = viewPort.width - fixedWidth - rightBarWidth;

  // limit the scale
  if (canvasAreaWidth / originCanvasWidth < MAX_CANVAS_SCALE) {
    canvasScale = canvasAreaWidth / originCanvasWidth;
  } else {
    canvasScale = MAX_CANVAS_SCALE;
    canvasAreaWidth = MAX_CANVAS_SCALE * originCanvasWidth;
  }

  return { canvasAreaWidth, sideBarWidth, canvasScale };
};

export const finalResizeWindow2 = ({
  canvasAreaWidth,
  studioItemType,
  canvasOverVignetteConfig,
  canvasResizeInfo,
  scale,
  dispatch,
  imprintAreaKey,
  sideBarWidth,
  itemStyleOriginSize,
  canvasData,
}) => {
  // save the max availableCanvasAreaWidth firstly
  dispatch(
    changeCanvasResizeParameters({
      imprintAreaKey,
      maxAvailableCanvasAreaWidth: canvasAreaWidth,
    })
  );

  let availableCanvasAreaWidth = canvasAreaWidth;
  if (
    studioItemType !== studioItemTypeEnum.nonDigital &&
    canvasOverVignetteConfig.vignette &&
    canvasOverVignetteConfig.canvasWidth > 0
  ) {
    const vignetteCanvasInfo = getVignetteCanvasInfo(canvasOverVignetteConfig);
    scale = scale * vignetteCanvasInfo.canvasRate;

    const result = adjustCanvasAreaWidth({
      availableCanvasAreaWidth,
      scale,
      canvasOverVignetteConfig,
      itemStyleOriginSize,
      canvasData,
      vignetteCanvasInfo,
    });
    availableCanvasAreaWidth = result.adjustedWidth;
    scale = result.scale;

    dispatch(
      changeCanvasResizeParameters({
        imprintAreaKey,
        availableCanvasAreaWidth,
      })
    );
    const actualCanvasWidth = availableCanvasAreaWidth * vignetteCanvasInfo.canvasRate;
    canvasAreaWidth = actualCanvasWidth;
  } else {
    // availableCanvasAreaWidth is required even if no canvas config
    dispatch(
      changeCanvasResizeParameters({
        imprintAreaKey,
        availableCanvasAreaWidth,
      })
    );
  }

  if (canvasResizeInfo && canvasResizeInfo.canvasZoom > 0) {
    const canvasZoom = 1 + canvasResizeInfo.canvasZoom / 100;
    scale = scale * canvasZoom;
    canvasAreaWidth = canvasAreaWidth * canvasZoom;
  }

  dispatch(
    changeCanvasResizeParameters({
      imprintAreaKey,
      sideBarWidth,
      canvasWidth: canvasAreaWidth,
      scale,
      pageHeight: getDeviceViewPort().height, // trigger refreshing if only vertical resize occurs.
    })
  );
};

export const getCanvasMaxHeight = () => {
  const screenMode = getScreenMode();
  const viewPort = getDeviceViewPort();
  let height =
    viewPort.height -
    (screenMode === nextgenScreenMode.small ? NEXTGEN_HEADER_TOPBAR_HEIGHT_SMALL : NEXTGEN_HEADER_TOPBAR_HEIGHT);
  height -= NEXTGEN_CANVAS_MARGIN_OUTSIDE;
  if (screenMode === nextgenScreenMode.small) height -= BOTTOM_SIDEBAR_HEIGHT;

  return Math.max(height, NEXTGEN_CANVAS_MIN_HEIGHT);
};

export const getVignetteCanvasAreaMaxHeight = () => {
  const screenMode = getScreenMode();
  return (
    getCanvasMaxHeight() -
    (screenMode === nextgenScreenMode.small ? DISCLAIMER_HEIGHT_SMALL_MODE : DISCLAIMER_HEIGHT) -
    CANVAS_RULER_AREA_WIDTH -
    (screenMode === nextgenScreenMode.small ? NEXTGEN_RIGHTBAR_HEIGHT : 0)
  );
};

const adjustCanvasAreaWidth = ({
  availableCanvasAreaWidth,
  scale,
  itemStyleOriginSize,
  canvasData,
  vignetteCanvasInfo,
}) => {
  const imageHeightWidthRate = vignetteCanvasInfo.vignetteImageHeight / vignetteCanvasInfo.vignetteTotalWidth;

  let height = Math.min(
    getCanvasMaxHeight() - NEXTGEN_CANVAS_MARGIN_INSIDE,
    availableCanvasAreaWidth * imageHeightWidthRate
  );
  if (itemStyleOriginSize.height > 0) {
    height = height * (canvasData.fullHeight / itemStyleOriginSize.height);
  }
  let adjustedWidth = (height / vignetteCanvasInfo.vignetteImageHeight) * vignetteCanvasInfo.vignetteTotalWidth;

  adjustedWidth = Math.max(adjustedWidth, NEXTGEN_CANVAS_MIN_WIDTH);
  scale = scale * (adjustedWidth / availableCanvasAreaWidth);
  return { adjustedWidth, scale };
};

export const handleCanvasKeyDown = (
  e,
  dispatch,
  studioItemType,
  canvasKey,
  elementList,
  focusElement,
  draggingArea
) => {
  const elementSelected = elementList.find((e) => e.ui.status === elementStatus.SingleSelected);

  switch (e.key) {
    case 'ArrowLeft':
    case 'ArrowUp':
    case 'ArrowRight':
    case 'ArrowDown':
      const element = elementSelected || focusElement;
      if (!element) return;
      const DELTA = 4;
      const elementData = element.data;
      const elementId = element.ui.guid;
      const newPosition = { x: elementData.x, y: elementData.y };
      if (e.key === 'ArrowLeft') newPosition.x = newPosition.x - DELTA;
      else if (e.key === 'ArrowUp') newPosition.y = newPosition.y - DELTA;
      else if (e.key === 'ArrowRight') newPosition.x = newPosition.x + DELTA;
      else if (e.key === 'ArrowDown') newPosition.y = newPosition.y + DELTA;

      const noRotateRect = { ...newPosition, width: elementData.width, height: elementData.height };
      const rotateResult = getRotateResult(getRectPoints(noRotateRect), -elementData.direction);
      const tempElement = {
        data: { x: newPosition.x, y: newPosition.y },
        ui: { outlineRect: rotateResult.outlineRect },
      };

      const isInDraggingArea = rotateResult.rotatedRectPoints.reduce(
        (a, p) => a && checkPointInRect(p, draggingArea),
        true
      );

      if (isInDraggingArea) {
        const adjustedRect = { ...newPosition, width: elementData.width, height: elementData.height };

        const realPos = getRealPosToKeepElementInside(
          draggingArea,
          { x: adjustedRect.x, y: adjustedRect.y },
          adjustedRect,
          elementData.direction,
          elementData.fontSize ? elementType.Text : elementType.Image
        );

        if (typeof elementData.imprintText != 'undefined')
          dispatch(
            changeTextPosition({
              canvasKey,
              textId: elementId,
              ...realPos,
            })
          );
        else {
          dispatch(
            changeImagePosition({
              canvasKey,
              imageId: elementId,
              ...realPos,
            })
          );
        }
        if (element === focusElement) {
          const newElement = Object.assign({}, element);
          newElement.data = Object.assign({}, newElement.data, realPos);
          dispatch(changeNextgenUiStatus({ canvasKey, canvasFocusElement: newElement }));
        }
      }
      e.preventDefault();
      return;
    case 'Tab':
      if (focusElement) {
        let index = elementList.indexOf(focusElement);
        if (e.shiftKey) {
          index = index - 1;
          if (index < 0) {
            dispatch(changeNextgenUiStatus({ canvasKey, canvasFocusElement: null }));
            return;
          }
        } else {
          index = index + 1;
          if (index === elementList.length) {
            dispatch(changeNextgenUiStatus({ canvasKey, canvasFocusElement: null }));
            return;
          }
        }
        dispatch(changeNextgenUiStatus({ canvasKey, canvasFocusElement: elementList[index] }));
      } else {
        if (e.shiftKey) {
          if (
            window.lastFocusedElement.id === nextgenNodeId.nextgenUndo ||
            window.lastFocusedElement.id === nextgenNodeId.nextgenRedo ||
            window.lastFocusedElement.id === nextgenNodeId.nextgenZoom
          ) {
            dispatch(changeNextgenUiStatus({ canvasKey, canvasFocusElement: elementList[elementList.length - 1] }));
            e.preventDefault();
          }
          return;
        }
        if (elementSelected) dispatch(changeNextgenUiStatus({ canvasKey, canvasFocusElement: elementSelected }));
        else dispatch(changeNextgenUiStatus({ canvasKey, canvasFocusElement: elementList[0] }));
      }
      e.preventDefault();
      return;
    case 'Enter':
      if (focusElement) {
        dispatch(unSelectAllImage({ canvasKey }));
        dispatch(unSelectAllText({ canvasKey }));
        if (typeof focusElement.data.imprintText != 'undefined')
          dispatch(selectText({ canvasKey, imageId: focusElement.ui.guid }));
        else dispatch(selectImage({ canvasKey, imageId: focusElement.ui.guid }));
        changePanelForSingleSelect(dispatch, focusElement.data, studioItemType);
      }
      return;
  }
};

export const getCanvasLeftTop = (canvasData, canvasScale, isNavInk) => {
  const canvasContainer = document.getElementById(domNodeId.canvasContainer);
  const clientRect = canvasContainer.getBoundingClientRect();

  let elementTop = clientRect.top;
  let elementLeft = clientRect.left;

  if (isNavInk) {
    const iframeDiv = document.getElementById('productConfigFrame');
    if (iframeDiv) {
      elementTop -= iframeDiv.getBoundingClientRect().top;
      elementLeft -= iframeDiv.getBoundingClientRect().left;
    }
  }
  elementTop -= canvasData.extraMarginY * canvasScale;

  return { x: elementLeft, y: elementTop };
};

export const getCanvasElementOutlines = ({ dispatch, elementData, canvasScale, canvasData, isNavInk }) => {
  const leftTop = getCanvasLeftTop(canvasData, canvasScale, isNavInk);
  let outlineRect1, rotatedRectPoints;

  const noRotateRect = {
    x: elementData.x * canvasScale,
    y: elementData.y * canvasScale,
    width: elementData.width * canvasScale,
    height: elementData.height * canvasScale,
  };
  const rotateResult1 = getRotateResult(getRectPoints(noRotateRect), -elementData.direction);
  outlineRect1 = rotateResult1.outlineRect;
  rotatedRectPoints = rotateResult1.rotatedRectPoints;

  const realElementOutlineRect = {
    x: leftTop.x + outlineRect1.x,
    y: leftTop.y + outlineRect1.y,
    width: outlineRect1.width,
    height: outlineRect1.height,
  };

  const realRotatedRectPoints = rotatedRectPoints.map((p) => {
    return { x: leftTop.x + p.x, y: leftTop.y + p.y };
  });
  return { realElementOutlineRect, realRotatedRectPoints };
};

export const getCanvasBatchTextOutline = ({ batchOutlineRect, canvasScale, canvasData, isNavInk }) => {
  const leftTop = getCanvasLeftTop(canvasData, canvasScale, isNavInk);

  return {
    x: batchOutlineRect.x * canvasScale + leftTop.x,
    y: batchOutlineRect.y * canvasScale + leftTop.y,
    width: batchOutlineRect.width * canvasScale,
    height: batchOutlineRect.height * canvasScale,
  };
};

export const getElementInitRect = (elementData, canvasScale, canvasData, isNavInk) => {
  const canvasLeftTop = getCanvasLeftTop(canvasData, canvasScale, isNavInk);
  return {
    x: canvasLeftTop.x + elementData.x * canvasScale,
    y: canvasLeftTop.y + elementData.y * canvasScale,
    width: elementData.width * canvasScale,
    height: elementData.height * canvasScale,
  };
};

export const getElementRealRect = (elementRect, canvasScale, canvasData, isNavInk) => {
  const leftTop = getCanvasLeftTop(canvasData, canvasScale, isNavInk);
  return {
    x: leftTop.x + elementRect.x * canvasScale,
    y: leftTop.y + elementRect.y * canvasScale,
    width: elementRect.width * canvasScale,
    height: elementRect.height * canvasScale,
  };
};

export const getElementRealPoints = (rotatedRectPoints, canvasScale, canvasData, isNavInk) => {
  const leftTop = getCanvasLeftTop(canvasData, canvasScale, isNavInk);
  return rotatedRectPoints.map((p) => {
    return {
      x: p.x * canvasScale + leftTop.x,
      y: p.y * canvasScale + leftTop.y,
    };
  });
};

export const rotateCanvasElement = (element) => {
  return rotateText(
    [
      { x: element.data.x, y: element.data.y },
      { x: element.data.x + element.data.width, y: element.data.y },
      { x: element.data.x + element.data.width, y: element.data.y + element.data.height },
      { x: element.data.x, y: element.data.y + element.data.height },
    ],
    360 - element.data.direction,
  );
};

export const getRotatedRectPoints = (rect, direction) => {
  const { x, y, width, height } = rect;

  const rectPoints = [
    {
      x,
      y,
    },
    {
      x: x + width,
      y,
    },
    {
      x: x + width,
      y: y + height,
    },
    {
      x,
      y: y + height,
    },
  ];

  const result = getRotateResult(rectPoints, 360 - direction);

  return result.rotatedRectPoints;
};

export const getCanvasContextMenuItems = (selectedElement, allowwCopy, batchText) => {
  const menuItems = [];

  menuItems.push(canvasContextMenuEnum.Edit);

  const canCrop =
    selectedElement &&
    (selectedElement.data.type === userImageType.UploadLogo || selectedElement.data.type === userImageType.SavedArt);

  const canSelectedTextCopy =
    (selectedElement && selectedElement.data.imprintText && selectedElement.data.imprintText.length > 0) ||
    (batchText &&
      batchText.length > 1 &&
      batchText.some((text) => text.data.imprintText && text.data.imprintText.length > 0));

  if (canCrop) menuItems.push(canvasContextMenuEnum.Crop);
  if (canSelectedTextCopy) {
    menuItems.push(canvasContextMenuEnum.Copy);
  } else if (selectedElement && typeof selectedElement.data.imprintText === 'undefined') {
    if (allowwCopy) menuItems.push(canvasContextMenuEnum.Copy);
  }

  menuItems.push(canvasContextMenuEnum.Delete);
  return menuItems;
};

export const getContextMenuItemsForCropping = () => {
  const menuItems = [];
  menuItems.push(canvasContextMenuEnum.CroppingApply);
  menuItems.push(canvasContextMenuEnum.CroppingCancel);
  menuItems.push(canvasContextMenuEnum.CropReset);
  return menuItems;
};

export const rotateRect = (rect, degree, centerPoint) => {
  const rectPoints = [
    { x: rect.x, y: rect.y },
    { x: rect.x + rect.width, y: rect.y },
    { x: rect.x + rect.width, y: rect.y + rect.height },
    { x: rect.x, y: rect.y + rect.height },
  ];

  centerPoint = centerPoint || getOutlineCenter(rectPoints);
  return rotate(rectPoints, centerPoint, degree);
};

export const rotateRectPoints = (rectPoints, degree, centerPoint) => {
  centerPoint = centerPoint || getOutlineCenter(rectPoints);
  return rotate(rectPoints, centerPoint, degree);
};

const rotate = (rectPoints, centerPoint, degree) => {
  const rotatedRectPoints = rotateByCenterPoint(rectPoints, centerPoint, degree);
  const outlineRect = getOutlineRect(rotatedRectPoints);
  return { rotatedRectPoints, outlineRect };
};

const rotateByCenterPoint = (rectPoints, centerPoint, degree) => {
  const rotatedRectPoints = [];
  rectPoints.forEach((rectPoint) => {
    const cartPoint = toCartesian(rectPoint, centerPoint);
    const rotatedPoint = rotatePoint(cartPoint, degree);
    rotatedRectPoints.push(toScreen(rotatedPoint, centerPoint));
  });
  return rotatedRectPoints;
};

const toCartesian = (rectPoint, centerPoint) => {
  return { x: rectPoint.x - centerPoint.x, y: -(rectPoint.y - centerPoint.y) };
};

const degreeToRadian = (degree) => {
  return (degree * Math.PI) / 180;
};

const rotatePoint = (point, degree) => {
  const angle = degreeToRadian(degree);
  return {
    x: point.x * Math.cos(angle) - point.y * Math.sin(angle),
    y: point.y * Math.cos(angle) + point.x * Math.sin(angle),
  };
};

const toScreen = (rotatedPoint, centerPoint) => {
  return { x: centerPoint.x + rotatedPoint.x, y: centerPoint.y - rotatedPoint.y };
};

const getOutlineRect = (rotatedRectPoints) => {
  const partListX = [];
  const partListY = [];
  rotatedRectPoints.forEach((point) => {
    partListX.push(point.x);
    partListY.push(point.y);
  });
  const minX = Math.min(...partListX);
  const minY = Math.min(...partListY);
  const maxX = Math.max(...partListX);
  const maxY = Math.max(...partListY);
  return { x: minX, y: minY, width: maxX - minX, height: maxY - minY };
};

export const getImageUrlForCanvasRotation = (url, imageData) => {
  const cropRect = imageData.cropRect;
  if (cropRect) url += '&crop=' + cropRect.x + ',' + cropRect.y + ',' + cropRect.width + ',' + cropRect.height;
  return url;
};

export const getImageRatioByLimitation = (imageElement, itemUseScene7Template) => {
  let imageRatioByLimitation = 1;
  if (imageElement.data.type === userImageType.UploadLogo) {
    if (itemUseScene7Template) {
      const scl = imageElement.data.originalWidth / MAX_CLOUD_IMAGE_SIZE;
      if (scl > 1) imageRatioByLimitation = scl;
    } else {
      // adjust the crop parameter if the image size is larger than 2000*2000 (only happens when reorder)
      let adjustedImageSize = { width: imageElement.data.originalWidth, height: imageElement.data.originalHeight };
      if (
        imageElement.data.originalWidth > MAX_UPLOAD_LOGO_SIZE ||
        imageElement.data.originalHeight > MAX_UPLOAD_LOGO_SIZE
      ) {
        adjustedImageSize = adjustImageSizeToFitContainer(
          { width: imageElement.data.originalWidth, height: imageElement.data.originalHeight },
          { width: MAX_UPLOAD_LOGO_SIZE, height: MAX_UPLOAD_LOGO_SIZE },
        );
      }
      if (
        adjustedImageSize.width !== imageElement.data.originalWidth ||
        adjustedImageSize.height !== imageElement.data.originalHeight
      ) {
        imageRatioByLimitation = imageElement.data.originalWidth / adjustedImageSize.width;
      }
    }
  }
  return imageRatioByLimitation;
};

export function resizeImageElement(dispatch, element, resizePercent, draggingArea, canvasKey) {
  if (typeof element.data.imprintText === 'undefined') {
    const center = getRectCenter(element.data);

    const percent = resizePercent * 0.9 + 10; // make sure percent is between 10 to 100
    const container = {
      width: (draggingArea.width * percent) / 100,
      height: (draggingArea.height * percent) / 100,
    };
    const oldOutlineRect = getRotateResult(getRectPoints(element.data), -element.data.direction).outlineRect;
    const newOutlineSize = adjustImageSizeToFitContainer(oldOutlineRect, container);

    const newElementSize = {
      width: element.data.width * (newOutlineSize.width / oldOutlineRect.width),
      height: element.data.height * (newOutlineSize.height / oldOutlineRect.height),
    };
    const newNoRotaedRect = {
      x: center.x - newElementSize.width / 2,
      y: center.y - newElementSize.height / 2,
      ...newElementSize,
    };
    dispatch(resizeElement({ imprintAreaKey: canvasKey, guid: element.ui.guid, ...newNoRotaedRect }));
    return { ...element, data: { ...element.data, ...newNoRotaedRect } };
  }
  return element;
}

export function adjustImageElementPositionAfterResize(dispatch, element, draggingArea, canvasKey) {
  let newPosition;
  const outlineRect = getRotateResult(getRectPoints(element.data), -element.data.direction).outlineRect;

  const isOutside = checkRectOutsideRect(outlineRect, draggingArea);
  if (isOutside) {
    const center = getRectCenter(draggingArea);
    newPosition = {
      x: center.x - element.data.width / 2,
      y: center.y - element.data.height / 2,
    };

    adjustForOnFoldLine(draggingArea, outlineRect, element, newPosition, isOutside);
    dispatch(changeImagePosition({ canvasKey, imageId: element.ui.guid, ...newPosition }));
  } else {
    newPosition = { x: element.data.x, y: element.data.y };
    adjustForOnFoldLine(draggingArea, outlineRect, element, newPosition, isOutside);
    dispatch(changeImagePosition({ canvasKey, imageId: element.ui.guid, ...newPosition }));
  }
}

const adjustForOnFoldLine = (draggingArea, outlineRect, element, newPosition, isOutside) => {
  if (draggingArea.isCalendar) {
    const isOnFold = isOnFoldLine(draggingArea, elementType.Image, outlineRect.x, outlineRect.width);
    if (isOutside || isOnFold) {
      if (outlineRect.width <= draggingArea.width / 2) {
        if (outlineRect.x + outlineRect.width / 2 - draggingArea.x < draggingArea.designCenter) {
          // most part is on the left
          newPosition.x = draggingArea.x + draggingArea.width * 0.25 - element.data.width / 2;
          newPosition.x--; // make sure left half is larger than right half
        } else {
          // most part is on the right
          newPosition.x = draggingArea.x + draggingArea.width * 0.75 - element.data.width / 2;
          newPosition.x++;
        }
      }
    }
  }
  return newPosition;
};

export function getResizePercent(element, draggingArea) {
  if (typeof element.data.imprintText === 'undefined') {
    const outlineRect = getRotateResult(getRectPoints(element.data), -element.data.direction).outlineRect;
    let percent = Math.max(outlineRect.width / draggingArea.width, outlineRect.height / draggingArea.height);
    return (percent * 100 - 10) / 0.9;
  }

  return 0;
}

export const getStepDataBlock = (specialSpellingWords, steps, activeStep) => {
  const colorWord = specialSpellingWords.color;

  if (!steps) return null;
  const firstStep = steps[0];
  let colorizeStepText;
  let textOffsetList2;
  let textOffsetList31;
  let textOffsetList32;
  let textOffsetList4;
  let barLengthList;

  if (isMobileOnly) {
    colorizeStepText = `${colorWord} Detection`;
    textOffsetList2 = [-25, 30];
    textOffsetList31 = [-60, -25, 30];
    textOffsetList32 = [-25, 30, 60];
    textOffsetList4 = [-30, -15, 20, 30];
    barLengthList = [80, 80];
  } else {
    colorizeStepText = [`${colorWord} Detection`, '& Editing'];
    textOffsetList2 = [-35, 40];
    textOffsetList31 = [-75, -25, 45];
    textOffsetList32 = [-51, 22, 90];
    textOffsetList4 = [-40, 0, 52, 60];
    barLengthList = [80, 120];
  }

  return steps.length === 2
    ? [
        {
          text: 'Crop',
          textOffset: textOffsetList2[0],
          active: activeStep === logoEditingStatusEnum.NonDigitalLogoCrop ? true : false,
          status: activeStep === logoEditingStatusEnum.NonDigitalLogoCrop ? stepStatus.Active : stepStatus.Done,
        },
        {
          text: 'Rotate',
          textOffset: textOffsetList2[1],
          active: activeStep === logoEditingStatusEnum.NonDigitalLogoRotate ? true : false,
          status: activeStep === logoEditingStatusEnum.NonDigitalLogoRotate ? stepStatus.Active : stepStatus.ToDo,
          barLength: 80,
        },
      ]
    : steps.length === 3
    ? firstStep === logoEditingStatusEnum.NonDigitalLogoRemoveWhite
      ? [
          {
            text: 'Remove White',
            textOffset: textOffsetList31[0],
            active: activeStep === logoEditingStatusEnum.NonDigitalLogoRemoveWhite ? true : false,
            status:
              activeStep === logoEditingStatusEnum.NonDigitalLogoRemoveWhite ? stepStatus.Active : stepStatus.Done,
          },
          {
            text: 'Crop',
            textOffset: textOffsetList31[1],
            active: activeStep === logoEditingStatusEnum.NonDigitalLogoCrop ? true : false,
            status:
              activeStep === logoEditingStatusEnum.NonDigitalLogoCrop
                ? stepStatus.Active
                : activeStep === logoEditingStatusEnum.NonDigitalLogoRemoveWhite
                ? stepStatus.ToDo
                : stepStatus.Done,
            barLength: 80,
          },
          {
            text: 'Rotate',
            textOffset: textOffsetList31[2],
            active: activeStep === logoEditingStatusEnum.NonDigitalLogoRotate ? true : false,
            status: activeStep === logoEditingStatusEnum.NonDigitalLogoRotate ? stepStatus.Active : stepStatus.ToDo,
            barLength: 80,
          },
        ]
      : [
          {
            text: 'Crop',
            textOffset: textOffsetList32[0],
            active: activeStep === logoEditingStatusEnum.NonDigitalLogoCrop ? true : false,
            status: activeStep === logoEditingStatusEnum.NonDigitalLogoCrop ? stepStatus.Active : stepStatus.Done,
          },
          {
            text: 'Rotate',
            textOffset: textOffsetList32[1],
            active: activeStep === logoEditingStatusEnum.NonDigitalLogoRotate ? true : false,
            status:
              activeStep === logoEditingStatusEnum.NonDigitalLogoRotate
                ? stepStatus.Active
                : activeStep === logoEditingStatusEnum.NonDigitalLogoCrop
                ? stepStatus.ToDo
                : stepStatus.Done,
            barLength: barLengthList[0],
          },
          {
            text: colorizeStepText,
            textOffset: textOffsetList32[2],
            active: activeStep === logoEditingStatusEnum.NonDigitalLogoColor ? true : false,
            status: activeStep === logoEditingStatusEnum.NonDigitalLogoColor ? stepStatus.Active : stepStatus.ToDo,
            barLength: barLengthList[1],
          },
        ]
    : //steps.length = 4
      [
        {
          text: 'Remove White',
          textOffset: textOffsetList4[0],
          active: activeStep === logoEditingStatusEnum.NonDigitalLogoRemoveWhite ? true : false,
          status: activeStep === logoEditingStatusEnum.NonDigitalLogoRemoveWhite ? stepStatus.Active : stepStatus.Done,
        },
        {
          text: 'Crop',
          textOffset: textOffsetList4[1],
          active: activeStep === logoEditingStatusEnum.NonDigitalLogoCrop ? true : false,
          status:
            activeStep === logoEditingStatusEnum.NonDigitalLogoCrop
              ? stepStatus.Active
              : activeStep === logoEditingStatusEnum.NonDigitalLogoRemoveWhite
              ? stepStatus.ToDo
              : stepStatus.Done,
          barLength: 60,
        },
        {
          text: 'Rotate',
          textOffset: textOffsetList4[2],
          active: activeStep === logoEditingStatusEnum.NonDigitalLogoRotate ? true : false,
          status:
            activeStep === logoEditingStatusEnum.NonDigitalLogoRotate
              ? stepStatus.Active
              : activeStep === logoEditingStatusEnum.NonDigitalLogoColor
              ? stepStatus.Done
              : stepStatus.ToDo,
          barLength: 60,
        },
        {
          text: colorizeStepText,
          textOffset: textOffsetList4[3],
          active: activeStep === logoEditingStatusEnum.NonDigitalLogoColor ? true : false,
          status: activeStep === logoEditingStatusEnum.NonDigitalLogoColor ? stepStatus.Active : stepStatus.ToDo,
          barLength: 60,
        },
      ];
};

export function getCorrectAutoCropRect(elementData) {
  let autoCropRect = elementData.autoCropRect;
  if (autoCropRect.width === 0 || autoCropRect.height == 0)
    autoCropRect = { ...autoCropRect, width: elementData.originalWidth, height: elementData.originalHeight };
  return autoCropRect;
}

export const getIsAppliedImageOnCanvas = (canvasImageList, imageData) => {
  const isApplied = canvasImageList.some((image) => {
    return (
      (image.data.type === userImageType.UploadLogo &&
        (image.data.originFileName === imageData.originFileName ||
          image.data.originFileName === imageData.description)) ||
      (image.data.type === userImageType.SharedArt && image.data.scene7FileName === imageData.scene7FileName)
    );
  });
  return isApplied;
};
